import { render, staticRenderFns } from "./ParametersList.vue?vue&type=template&id=2ae5ce51"
import script from "./ParametersList.js?vue&type=script&lang=js&external"
export * from "./ParametersList.js?vue&type=script&lang=js&external"
import style0 from "./ParametersList.vue?vue&type=style&index=0&id=2ae5ce51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports